export default `Name,Population
United Kindom,66796807
Great Brtian,64903140
England and Wales,59439840
England,56286961
North East,2669941
North West,7341196
Yorkshire and The Humber,5502967
East Midlands,4835928
West Midlands,5934037
East of England,6236072
London,8961989
South East,9180135
South West,5624696
Wales,3152879
Scotland,5463300
Northern Ireland,1893667`